module.exports = __webpack_public_path__ + "img/thailand.b04425e4.svg";